import axios from 'axios'
import { useEffect, useState } from 'react'
import Layout from '../../layout'
import { TabelFaq } from './components'

// REDUX
import { useDispatch, useSelector } from 'react-redux'
import { selectCurrentUser } from '../../redux/user/user.selectors'
import { removeCurrentUser } from '../../redux/user/user.action'

import FetchLoading from '../../components/FetchLoading'
import ButtonLink from '../../components/ButtonLink'
import { message } from 'antd'
import { useNavigate } from 'react-router-dom'

const Faq = () => {
  const currentUser = useSelector(selectCurrentUser)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [faqs, setFaqs] = useState(null)

  useEffect(() => {
    axios({
      method: 'get',
      url: '/faq',
      headers: {
        Authorization: `Bearer ${currentUser.token}`,
      },
    })
      .then(({ data }) => {
        setFaqs(data)
      })
      .catch(function (error) {
        if (error.response.status === 404) {
          message.error('404 Not Found')
        }
        if (error.response.status === 401) {
          message.error('401 Unauthorized')
          dispatch(removeCurrentUser())
          navigate('/login')
        }
        if (error.response.status === 500) {
          message.error('500 Internal Server Error ')
        }
        if (error.response.status === 403) {
          message.error('403 Forbidden')
        }
      })
  }, [currentUser.token, dispatch, navigate])

  return (
    <Layout id="faq" title="FAQ">
      <ButtonLink urlRoute="/faq/faq-tambah" title="Tambah FAQ" />
      <FetchLoading data={faqs}>
        <TabelFaq faqs={faqs} />
      </FetchLoading>
    </Layout>
  )
}

export default Faq
